/**
 * New Listing — Insurance (redirect only)
 *
 * Early access pins every listing to the agency coverage model, so there is no
 * insurance step to fill in: the route exists for old deep links and forwards
 * to documents. It used to `return null` while redirecting, which paints a
 * full-screen white page in both themes — the exact failure GateFallback was
 * built for (see components/ui/GateFallback.tsx).
 */
import { useEffect } from 'react'
import { useRouter } from 'expo-router'
import { useTranslation } from 'react-i18next'
import { GateFallback } from '@/components/ui/GateFallback'
import { useListingWizardStore } from '@/lib/stores/listing-wizard.store'
import { EARLY_ACCESS } from '@/lib/utils/constants'

export default function NewListingInsuranceRedirect() {
  const { t } = useTranslation()
  const router = useRouter()
  const setPricing = useListingWizardStore((s) => s.setPricing)

  useEffect(() => {
    setPricing({ insuranceModel: EARLY_ACCESS.hostInsuranceModel })
    // Point the wizard at where we are sending it, not at where it came from.
    // `documents` is WIZARD_STEPS index 5; the layout no longer overrides this
    // with step 0 for routes that are not wizard steps.
    useListingWizardStore.getState().goToStep(5)
    router.replace('/hosting/new-listing/documents' as never)
  }, [router, setPricing])

  return (
    <GateFallback
      accessibilityLabel={t('listing.insurance_redirect_a11y')}
      testID="listing.insurance-redirect"
    />
  )
}
